import { render, staticRenderFns } from "./PortalCrazyCard.vue?vue&type=template&id=c6417532&"
import script from "./PortalCrazyCard.vue?vue&type=script&lang=js&"
export * from "./PortalCrazyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports